<template>
<div>
  <section class="content-header">
    <h1>
      VoIP运营数据
      <small>VoIP运营数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/voipOperate/voipOperate">VoIP运营数据</a></li>
      <li class="active">VoIP运营数据</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customers" multiple filterable clearable placeholder="客户名称">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">VoIP充值卡数量统计</span>
      </div>
      <div class="echart">
        <IEcharts :option="rechargeCard" :resizable="true" :loading="loading1"></IEcharts>
      </div>
      <el-pagination
        @current-change="handleCurrentChange1"
        :current-page.sync="currentPage1"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total1">
      </el-pagination>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">VoIP充值卡使用数量统计</span>
      </div>
      <div class="echart">
        <IEcharts :option="rechargeCardUse" :resizable="true" :loading="loading2"></IEcharts>
      </div>
      <el-pagination
        @current-change="handleCurrentChange2"
        :current-page.sync="currentPage2"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total2">
      </el-pagination>
    </el-card>

    <el-card class="box-card" >
      <el-row :gutter="40" justify="center">
        <el-col :xs="24" :sm="12" :md="8">
          <center>
            <el-tooltip class="item" effect="dark" content="已使用次数 / 已充值次数" placement="top">
              <h5>使用率</h5>
            </el-tooltip>
            <el-progress type="circle" :percentage="useRate"></el-progress>
          </center>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <center>
            <el-tooltip class="item" effect="dark" content="取消次数 / 已预约次数" placement="top">
              <h5>取消率</h5>
            </el-tooltip>
            <el-progress type="circle" :percentage="cancelRate"></el-progress>
          </center>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <center>
            <el-tooltip class="item" effect="dark" content="预约课程大于等于两次的用户数 / 所有使用次数的用户数" placement="top">
              <h5>续约率</h5>
            </el-tooltip>
            <el-progress type="circle" :percentage="continueRate"></el-progress>
          </center>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">预约课程排行榜</span>
      </div>
      <div class="echart one-two">
        <IEcharts :option="subOne2one" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <div class="echart one-two">
        <IEcharts :option="subOne2many" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">VoIP学习时间分布</span>
      </div>
      <div class="echart one-two">
        <IEcharts :option="durationSpread" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <div class="echart one-two">
        <IEcharts :option="weekSpread" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadRechargeCard, loadRechargeCardUsed, loadThreeRates, loadSubCourseRank, loadTimeSpread} from 'api/voip-operate'
import {extractArrsFromObj, withRank, parseTwoArray} from 'common/js/app-utils'
// import {Loading} from 'element-ui'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes'
    ])
  },
  data () {
    return {
      currentPage1: 1,
      currentPage2: 1,
      total1: 0,
      total2: 0,
      pageSize: 10,

      currentDate: new Date(),
      filters: {
        customers: [],
        dateRange: [],
        orgType: ''
      },

      loading1: true,
      loading2: true,
      loading: true,
      useRate: 0,
      cancelRate: 0,
      continueRate: 0,
      rechargeCard: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['一对一', '一对多', '合计']
        },
        grid: {x: '17%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [{
          name: '一对一',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: []
        }, {
          name: '一对多',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: []
        }, {
          name: '合计',
          type: 'bar',
          barWidth: 4,
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          data: []
        }],
        color: ['rgba(255, 0, 0, 1)', 'rgb(91,155,213)', 'rgba(34, 45, 50, 1)']
      },
      rechargeCardUse: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['一对一', '一对多', '合计']
        },
        grid: {x: '17%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: ['school1', 'school1', 'school1', 'school1', 'school1']
        },
        series: [{
          name: '一对一',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: [1, 2, 3, 4, 10]
        }, {
          name: '一对多',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: [1, 2, 3, 4, 5]
        }, {
          name: '合计',
          type: 'bar',
          barWidth: 4,
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          data: [2, 4, 6, 8, 15]
        }],
        color: ['rgba(255, 0, 0, 1)', 'rgb(91,155,213)', 'rgba(34, 45, 50, 1)']
      },
      subOne2one: {
        title: {
          text: '一对一',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '14%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '数量',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      subOne2many: {
        title: {
          text: '一对多',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '14%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      durationSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '技能分布',
            type: 'line',
            lineStyle: {
              normal: {
                width: 3,
                color: 'rgb(91,155,213)',
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10
              }
            },
            data: [],
            color: ['rgb(91,155,213)']
          }
        ]
      },
      weekSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '技能分布',
            type: 'line',
            lineStyle: {
              normal: {
                width: 3,
                color: 'rgb(91,155,213)',
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10
              }
            },
            data: [],
            color: ['rgb(91,155,213)']
          }
        ]
      }
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    handleCurrentChange1 (val) {
      this._loadRechargeCard(val, this.pageSize)
    },
    handleCurrentChange2 (val) {
      this._loadRechargeCardUsed(val, this.pageSize)
    },
    query () {
      this._loadRechargeCard(1, this.pageSize)
      this._loadRechargeCardUsed(1, this.pageSize)
      this._loadThreeRates()
      this._loadSubCourseRank()
      this._loadTimeSpread()
    },
    _loadRechargeCard (page, pageSize) {
      this.loading1 = true
      loadRechargeCard(page, pageSize, this.filters)
      .then((res) => {
        this.loading1 = false
        let arrs = extractArrsFromObj(res.rows, ['school', 'one2one', 'one2many', 'all', 'rank'])
        this.rechargeCard.yAxis.data = withRank(arrs.school, arrs.rank)
        this.rechargeCard.series[0].data = arrs.one2one
        this.rechargeCard.series[1].data = arrs.one2many
        this.rechargeCard.series[2].data = arrs.all
        this.total1 = res.total
      }, (msg) => {
        this.loading1 = false
        this.$message.error(msg)
      })
    },
    _loadRechargeCardUsed (page, pageSize) {
      this.loading2 = true
      loadRechargeCardUsed(page, pageSize, this.filters)
      .then((res) => {
        this.loading2 = false
        let arrs = extractArrsFromObj(res.rows, ['school', 'one2one', 'one2many', 'all', 'rank'])
        this.rechargeCardUse.yAxis.data = withRank(arrs.school, arrs.rank)
        this.rechargeCardUse.series[0].data = arrs.one2one
        this.rechargeCardUse.series[1].data = arrs.one2many
        this.rechargeCardUse.series[2].data = arrs.all
        this.total2 = res.total
      }, (msg) => {
        this.loading2 = false
        this.$message.error(msg)
      })
    },
    _loadThreeRates () {
      loadThreeRates(this.filters)
      .then((res) => {
        this.useRate = res.useRate
        this.cancelRate = res.cancelRate
        this.continueRate = res.continueRate
      }, (msg) => {
        this.$message.error(msg)
      })
    },
    _loadSubCourseRank () {
      this.loading = true
      loadSubCourseRank(this.filters)
      .then((res) => {
        this.loading = false
        let arr1 = extractArrsFromObj(res.one2one, ['course', 'num', 'rank'])
        let arr2 = extractArrsFromObj(res.one2many, ['course', 'num', 'rank'])
        this.subOne2one.yAxis.data = withRank(arr1.course, arr1.rank)
        this.subOne2one.series[0].data = arr1.num
        this.subOne2many.yAxis.data = withRank(arr2.course, arr2.rank)
        this.subOne2many.series[0].data = arr2.num
      }, (msg) => {
        this.loading = false
        this.$message.error(msg)
      })
    },
    _loadTimeSpread () {
      this.loading = true
      loadTimeSpread(this.filters)
      .then((res) => {
        this.loading = false
        let duration = parseTwoArray(res.duration)
        let week = parseTwoArray(res.week)

        this.durationSpread.xAxis.data = duration.keys
        this.durationSpread.series[0].data = duration.values
        this.weekSpread.xAxis.data = week.keys
        this.weekSpread.series[0].data = week.values
      }, (msg) => {
        this.loading = false
        this.$message.error(msg)
      })
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/voip-operate/voip-operate.vue